module.exports = __webpack_public_path__ + "static/media/aroma-narrow.fd69d27a.png";